// @flow strict
import * as React from 'react';

import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'src/rerouter';
import {useEnvironmentContext} from 'src/hooks/useEnvironmentContext';
import {useWebAndExtRouterControl} from 'src/components/micro-apps-extension/hooks/useWebAndExtRouterControl';

// $FlowFixMe[nonstrict-import]
import {EXTENSION_ID} from 'src/chat-extension/constants';
import logger from 'src/utils/logger';

// $FlowFixMe[untyped-import]
import PortContext from 'src/components/messaging/port-context';

import {
  // $FlowFixMe[nonstrict-import]
  setMeetingsScheduleEventData,
} from 'src/action-creators/messages';
// $FlowFixMe[nonstrict-import]
import {routeExternalContact} from 'src/action-creators/contacts';

import {
  // $FlowFixMe[untyped-import]
  CLICKED_NUMBER,
  // $FlowFixMe[untyped-import]
  PORT_OPEN,
  // $FlowFixMe[untyped-import]
  ANALYTICS_TRACK,
  // $FlowFixMe[untyped-import]
  MEETING_SCHEDULE_EVENT,
} from 'src/chat-extension/messages';
// $FlowFixMe[untyped-import]
import {isAgentSelectedForAmplitudeTracking} from 'src/selectors/messages-v2';

import {AnalyticsService} from 'src/analytics';
import {getMessagingTrackingMetrics} from 'src/components/messaging/messaging-amplitude-helper.js';


const initialExtensionTimeout = 200;

const ExtensionConnection = ({
  children,
}: {
  children: React.Node,
}): React.Node => {
  const {isExtension} = useEnvironmentContext();
  const {changeLocation} = useWebAndExtRouterControl();
  const router = useHistory();
  const dispatch = useDispatch();
  const agency = useSelector((state) => state.agency.agency.name);
  const agencies = ['HCAHealthcare', 'HCA-Infor-Sandbox', 'HCA-Infor-UAT'];
  const trackHCAEvent = agencies.includes(agency);

  const [extensionPortValue, setExtensionPortValue] = React.useState(null);
  const [extensionConnectionTimeout, setExtensionConnectionTimeout] =
    React.useState(initialExtensionTimeout);
  const trackAmplitudeEvent = useSelector(isAgentSelectedForAmplitudeTracking);

  const handleMessage = (message) => {
    if (message.type === PORT_OPEN) {
      setExtensionConnectionTimeout(initialExtensionTimeout);
    } else if (message.type === MEETING_SCHEDULE_EVENT) {
      logger.log('[HCA Schedule now] data received from extension', message);
      logger.log(
        '[HCA Schedule now] routing to meetings/schedule-now',
        message,
      );
      const payload = message.payload;
      if (trackHCAEvent) {
        AnalyticsService.track('HCA MEETING_SCHEDULE_EVENT data received', {
          payload,
          line: 86,
        });
      }
      setTimeout(() => {
        dispatch(setMeetingsScheduleEventData(payload));
        changeLocation(router, {
          ...router.location,
          pathname: '/meetings/schedule-now',
        });
        logger.log(
          '[HCA Schedule now] data set to the store for meetings',
          message,
        );
        if (trackHCAEvent) {
          AnalyticsService.track(
            'HCA MEETING_SCHEDULE_EVENT data set to store',
            {
              payload,
              line: 96,
            },
          );
        }
      }, 0);
    } else if (message.type === CLICKED_NUMBER) {
      setTimeout(() => {
        dispatch(routeExternalContact(router, message));
        if (trackAmplitudeEvent) {
          const trackingDetails = getMessagingTrackingMetrics();
          AnalyticsService.track('Extension Number Clicked', trackingDetails);
        }
      }, 0);
    } else if (message.type === ANALYTICS_TRACK) {
      const {event, data} = message.payload;
      setTimeout(() => {
        if (event === 'EXTENSION ATS URL') {
          // we need only the domain names of the bullhorn ATS
          if (data?.url?.includes('bullhorn')) {
            const trackingDetails = getMessagingTrackingMetrics();
            AnalyticsService.track(event, {
              trackingDetails,
              ...data,
            });
          }
        } else {
          if (trackAmplitudeEvent) {
            const trackingDetails = getMessagingTrackingMetrics();
            AnalyticsService.track(event, {
              trackingDetails,
              ...data,
            });
          }
        }
      }, 0);
    }
  };

  const handleDisconnect = (port) => {
    const error =
      port.error ||
      (window.chrome &&
        window.chrome.runtime &&
        window.chrome.runtime.lastError);
    logger.log('Port disconnecting');
    if (error) {
      logger.error('Disconnected from extension.', error);
    }

    port.onMessage.removeListener(handleMessage);

    logger.log(
      `Attempting to reconnect to extension in ${extensionConnectionTimeout}ms...`,
    );
    setTimeout(() => connectToExtension(), extensionConnectionTimeout);
    setExtensionConnectionTimeout((prev) => prev * 2);
    setExtensionPortValue(null);
  };

  const connectToExtension = () => {
    const extensionPort = window.chrome.runtime.connect(EXTENSION_ID, {
      name: 'chat-iframe',
    });
    setExtensionPortValue(extensionPort);
    if (extensionPort) {
      extensionPort.onMessage.addListener(handleMessage);
      extensionPort.onDisconnect.addListener(handleDisconnect);
    }
  };

  React.useEffect(() => {
    if (window.chrome && window.chrome.runtime && isExtension) {
      connectToExtension();
    }
  }, []);

  return (
    <PortContext.Provider value={extensionPortValue}>
      {children}
    </PortContext.Provider>
  );
};

export default ExtensionConnection;
